'use client';

import { c as _c } from "react/compiler-runtime";
import { TransformComponent, TransformWrapper } from 'react-zoom-pan-pinch';
import { INITIAL_SCALE, MAX_SCALE, MIN_SCALE, WHEEL_SMOOTH_STEP } from '@/app/components/image-zoom-pan-pinch/image-zoom.constants';
import type { ImageZoomPanPinchProps } from '@/app/components/image-zoom-pan-pinch/types';
import { Image } from '@/app/components/media/image';
import { cn } from '@/app/utils/cn';
import { createDataAttributes } from '@/app/utils/createDataAttributes';
const IMAGE_ZOOM_PAN_PINCH_FALLBACK_IMAGE_SIZE = '(min-width: 1280px) 1176px, (min-width: 768px) calc(100vw - 80px), (min-width: 480px) calc(100vw - 48px), calc(100vw - 32px)';
const getImageSize = (width: number): `${number}px` | typeof IMAGE_ZOOM_PAN_PINCH_FALLBACK_IMAGE_SIZE => {
  const roundedWidth = Math.ceil(width);
  return roundedWidth > 0 ? `${roundedWidth}px` : IMAGE_ZOOM_PAN_PINCH_FALLBACK_IMAGE_SIZE;
};
export const ImageZoomPanPinch = t0 => {
  const $ = _c(59);
  const {
    zoom,
    src,
    alt,
    normalizedWidth,
    normalizedHeight,
    imageDataTestId,
    transformInstanceKey: t1
  } = t0;
  const transformInstanceKey = t1 === undefined ? src : t1;
  const {
    transformRef,
    imageStageRef,
    _panning: panning,
    _imageCursorClassName: imageCursorClassName,
    _syncCurrentScaleImmediately: syncCurrentScaleImmediately,
    _scheduleCurrentScaleSync: scheduleCurrentScaleSync,
    _handleRecenterAtInitialScale: handleRecenterAtInitialScale,
    _updatePanCapability: updatePanCapability,
    _handlePointerDown: handlePointerDown,
    _handlePointerMove: handlePointerMove,
    _handlePointerEnd: handlePointerEnd,
    inlineImageSize
  } = zoom;
  let t2;
  if ($[0] !== inlineImageSize.width) {
    t2 = getImageSize(inlineImageSize.width);
    $[0] = inlineImageSize.width;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const imageSize = t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      disabled: true
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      step: 5
    };
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      step: WHEEL_SMOOTH_STEP
    };
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== syncCurrentScaleImmediately || $[6] !== updatePanCapability) {
    t6 = ref => {
      syncCurrentScaleImmediately(ref.state.scale);
      updatePanCapability(ref);
    };
    $[5] = syncCurrentScaleImmediately;
    $[6] = updatePanCapability;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  let t8;
  if ($[8] !== handleRecenterAtInitialScale || $[9] !== syncCurrentScaleImmediately || $[10] !== updatePanCapability) {
    t7 = ref_0 => {
      syncCurrentScaleImmediately(ref_0.state.scale);
      updatePanCapability(ref_0);
      handleRecenterAtInitialScale(ref_0);
    };
    t8 = ref_1 => {
      syncCurrentScaleImmediately(ref_1.state.scale);
      updatePanCapability(ref_1);
      handleRecenterAtInitialScale(ref_1);
    };
    $[8] = handleRecenterAtInitialScale;
    $[9] = syncCurrentScaleImmediately;
    $[10] = updatePanCapability;
    $[11] = t7;
    $[12] = t8;
  } else {
    t7 = $[11];
    t8 = $[12];
  }
  let t9;
  if ($[13] !== scheduleCurrentScaleSync) {
    t9 = (_, state) => {
      scheduleCurrentScaleSync(state.scale);
    };
    $[13] = scheduleCurrentScaleSync;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  let t11;
  if ($[15] !== handleRecenterAtInitialScale || $[16] !== syncCurrentScaleImmediately || $[17] !== updatePanCapability) {
    t10 = ref_2 => {
      syncCurrentScaleImmediately(ref_2.state.scale);
      updatePanCapability(ref_2);
      handleRecenterAtInitialScale(ref_2);
    };
    t11 = ref_3 => {
      syncCurrentScaleImmediately(ref_3.state.scale);
      updatePanCapability(ref_3);
      handleRecenterAtInitialScale(ref_3);
    };
    $[15] = handleRecenterAtInitialScale;
    $[16] = syncCurrentScaleImmediately;
    $[17] = updatePanCapability;
    $[18] = t10;
    $[19] = t11;
  } else {
    t10 = $[18];
    t11 = $[19];
  }
  let t12;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = {
      onMouseDown: _temp2
    };
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== imageCursorClassName) {
    t13 = cn("touch-none overflow-visible! will-change-transform", imageCursorClassName);
    $[21] = imageCursorClassName;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = {
      onMouseDown: _temp3
    };
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  let t15;
  if ($[24] !== inlineImageSize.height || $[25] !== inlineImageSize.width) {
    t15 = {
      width: inlineImageSize.width,
      height: inlineImageSize.height
    };
    $[24] = inlineImageSize.height;
    $[25] = inlineImageSize.width;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  let t16;
  if ($[27] !== imageDataTestId) {
    t16 = createDataAttributes({
      test: imageDataTestId
    });
    $[27] = imageDataTestId;
    $[28] = t16;
  } else {
    t16 = $[28];
  }
  let t17;
  if ($[29] !== alt || $[30] !== imageSize || $[31] !== normalizedHeight || $[32] !== normalizedWidth || $[33] !== src) {
    t17 = <Image src={src} alt={alt} width={normalizedWidth} height={normalizedHeight} layout="fill" objectFit="contain" sizes={imageSize} aspectRatio="calculate" loadedEffect="none" />;
    $[29] = alt;
    $[30] = imageSize;
    $[31] = normalizedHeight;
    $[32] = normalizedWidth;
    $[33] = src;
    $[34] = t17;
  } else {
    t17 = $[34];
  }
  let t18;
  if ($[35] !== t15 || $[36] !== t16 || $[37] !== t17) {
    t18 = <div className="relative" style={t15} {...t16}>{t17}</div>;
    $[35] = t15;
    $[36] = t16;
    $[37] = t17;
    $[38] = t18;
  } else {
    t18 = $[38];
  }
  let t19;
  if ($[39] !== t13 || $[40] !== t18) {
    t19 = <TransformComponent contentClass="will-change-transform" contentProps={t12} wrapperClass={t13} wrapperProps={t14}>{t18}</TransformComponent>;
    $[39] = t13;
    $[40] = t18;
    $[41] = t19;
  } else {
    t19 = $[41];
  }
  let t20;
  if ($[42] !== handlePointerDown || $[43] !== handlePointerEnd || $[44] !== handlePointerMove || $[45] !== imageStageRef || $[46] !== t19) {
    t20 = <div ref={imageStageRef} className="flex size-full items-center justify-center outline-none" onMouseDown={_temp} onPointerCancel={handlePointerEnd} onPointerDown={handlePointerDown} onPointerLeave={handlePointerEnd} onPointerMove={handlePointerMove} onPointerUp={handlePointerEnd}>{t19}</div>;
    $[42] = handlePointerDown;
    $[43] = handlePointerEnd;
    $[44] = handlePointerMove;
    $[45] = imageStageRef;
    $[46] = t19;
    $[47] = t20;
  } else {
    t20 = $[47];
  }
  let t21;
  if ($[48] !== panning || $[49] !== t10 || $[50] !== t11 || $[51] !== t20 || $[52] !== t6 || $[53] !== t7 || $[54] !== t8 || $[55] !== t9 || $[56] !== transformInstanceKey || $[57] !== transformRef) {
    t21 = <TransformWrapper key={transformInstanceKey} ref={transformRef} centerOnInit={true} disablePadding={true} doubleClick={t3} initialScale={INITIAL_SCALE} limitToBounds={true} maxScale={MAX_SCALE} minScale={MIN_SCALE} panning={panning} pinch={t4} smooth={true} wheel={t5} onInit={t6} onPanningStop={t7} onPinchStop={t8} onTransform={t9} onWheelStop={t10} onZoomStop={t11}>{t20}</TransformWrapper>;
    $[48] = panning;
    $[49] = t10;
    $[50] = t11;
    $[51] = t20;
    $[52] = t6;
    $[53] = t7;
    $[54] = t8;
    $[55] = t9;
    $[56] = transformInstanceKey;
    $[57] = transformRef;
    $[58] = t21;
  } else {
    t21 = $[58];
  }
  return t21;
};
function _temp(event) {
  return event.preventDefault();
}
function _temp2(event_0) {
  return event_0.preventDefault();
}
function _temp3(event_1) {
  return event_1.preventDefault();
}